module.exports = __webpack_public_path__ + "img/神州集团.258bf1c5.png";